import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, Navigate, RouterProvider, useNavigate } from "react-router-dom";
import { Provider } from "react-redux";

// Css
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
// Css ---- End

// Components
import Layout from "./Layout/index";
import SignIn from "./components/Auth/SignIn";
import Dashboard from "./components/Dashboard";
import Village from "./components/Village";
import AddVillage from "./components/Village/addVillage";
import Surname from "./components/Surname";
import Business from "./components/Business";
import AddBusiness from "./components/Business/addbusiness";
import Relation from "./components/Relation";
import AddRelation from "./components/Relation/addrelation";
import AddSurname from "./components/Surname/addsurname";
import Members from "./components/Members";
import PendingMembers from "./components/PendingMembers";
import SubAdmin from "./components/SubAdmin";
import AddSubAdmin from "./components/SubAdmin/addsubadmin";
import PendingAds from "./components/Ads/pendingAds";
import LiveAds from "./components/Ads";
import PendingEvents from "./components/Events/pending";
import LiveEvents from "./components/Events/live";
import PendingNews from "./components/News/pending";
import LiveNews from "./components/News/live";
// Components ---- End

// Redux store
import { store } from "./Helpers/Redux/store";
import { Toaster } from "react-hot-toast";
import SadDemise from "./components/SadDemise";
import PendingDemise from "./components/SadDemise/pending";
// Redux store ---- End

// 🔐 Helper to get token with expiry check
const getStoredToken = () => {
  const itemStr = localStorage.getItem(process.env.REACT_APP_SECRET_KEY);
  if (!itemStr) return null;
  return itemStr;
};

// 🔐 ProtectedRoute component
const ProtectedRoute = ({ children }) => {
  const token = getStoredToken();
  if (!token) {
    return <Navigate to="/" replace />;
  }
  return children;
};

// 🌀 Auto redirect if token exists (on login page)
const SignInWithRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = getStoredToken();
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  return <SignIn />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <SignInWithRedirect />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Layout>
          <Dashboard />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/villages",
    element: (
      <ProtectedRoute>
        <Layout>
          <Village />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/add-village",
    element: (
      <ProtectedRoute>
        <Layout>
          <AddVillage />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/surname",
    element: (
      <ProtectedRoute>
        <Layout>
          <Surname />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/add-surname",
    element: (
      <ProtectedRoute>
        <Layout>
          <AddSurname />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/business",
    element: (
      <ProtectedRoute>
        <Layout>
          <Business />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/add-business",
    element: (
      <ProtectedRoute>
        <Layout>
          <AddBusiness />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/relation",
    element: (
      <ProtectedRoute>
        <Layout>
          <Relation />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/add-relation",
    element: (
      <ProtectedRoute>
        <Layout>
          <AddRelation />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/members",
    element: (
      <ProtectedRoute>
        <Layout>
          <Members />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/sub-admin",
    element: (
      <ProtectedRoute>
        <Layout>
          <SubAdmin />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/add-sub-admin",
    element: (
      <ProtectedRoute>
        <Layout>
          <AddSubAdmin />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/pending-sad-demise",
    element: (
      <ProtectedRoute>
        <Layout>
          <PendingDemise />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/sad-demise",
    element: (
      <ProtectedRoute>
        <Layout>
          <SadDemise />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/pending-members",
    element: (
      <ProtectedRoute>
        <Layout>
          <PendingMembers />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/pending-news",
    element: (
      <ProtectedRoute>
        <Layout>
          <PendingNews />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/live-news",
    element: (
      <ProtectedRoute>
        <Layout>
          <LiveNews />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/ads",
    element: (
      <ProtectedRoute>
        <Layout>
          <PendingAds />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/live-ads",
    element: (
      <ProtectedRoute>
        <Layout>
          <LiveAds />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/pending-event",
    element: (
      <ProtectedRoute>
        <Layout>
          <PendingEvents />
        </Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/live-event",
    element: (
      <ProtectedRoute>
        <Layout>
          <LiveEvents />
        </Layout>
      </ProtectedRoute>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
    <Toaster />
  </React.StrictMode>
);
